import { buildClicktermPromoUrl } from '../shared/components/clickterm-promo-banner/clickterm-promo-url';
import { NewsItem } from './news.model';

/**
 * The feed is static for now. It is built through a function rather than exported as a
 * const so the ClickTerm URL is assembled per call, keeping attribution in one place.
 */
export function buildNewsFeed(): NewsItem[] {
  return [
    {
      id: 'clickterm-launch',
      publishedOn: '2026-08-13',
      category: 'New product',
      title: 'Meet ClickTerm, clickwrap agreements that hold up',
      summary:
        'ClickTerm turns your terms of service, DPAs and MSAs into clickwrap agreements that are legally binding, and keeps an audit trail of every acceptance.',
      details: [
        'Version an agreement, capture exactly what each user accepted and when, and export that evidence when legal or a customer asks for it.',
        'If your product asks users to agree to anything, ClickTerm saves your team building and maintaining that flow.',
      ],
      link: { label: 'Explore ClickTerm', url: buildClicktermPromoUrl('news') },
      featured: true,
    },
    {
      id: 'news-page',
      publishedOn: '2026-08-13',
      category: 'Platform update',
      title: 'Announcements now have a home',
      summary:
        'This page collects product news and platform updates. Anything you dismiss elsewhere in the app stays available here, so you can come back to it whenever you like.',
    },
  ];
}
